import React, { useState } from 'react'
import { Box, Typography } from '@mui/material'
import IconTooltipButton from '../../../../button/IconTooltipButton'
import { useSelector } from 'react-redux'
import DataGrid from '../../../../table/DataGrid'
import DialogGrowthGoals from './DialogGrowthGoals'

const FormGrowthGoals = ({ onChangeAlert, isLoading }) => {
  const [modal, setModal] = useState(null)
  const formData = useSelector((state) => state?.dr?.form?.growthGoals || [])
  const onSave = (data, type) => {
    if (type === 'create') {
      const newQuestion = {
        _id: data._id || new Date().getTime(),
        id: data._id || new Date().getTime(),
        question: data.question
      }
      onChangeAlert('growthGoals', [...formData, newQuestion])
    } else if (type === 'edit') {
      const newFormData = formData.map((item) => ({ ...item, _id: item._id || item.id })).map((item) => {
        if (String(item._id) === String(data.id)) {
          return {
            ...item,
            question: data.question
          }
        }
        return item
      })
      onChangeAlert('growthGoals', newFormData)
    } else if (type === 'delete') {
      const newFormData = formData.map((item) => ({ ...item, _id: item._id || item.id })).filter((item) => String(item._id) !== String(data.id))
      onChangeAlert('growthGoals', newFormData)
    }
  }

  return (
    <>
      <Box className='px-4 py-2 h-6 bg-primary text-primary-foreground flex items-center justify-between'>
        <Typography variant='inherit' className='font-bold capitalize' component='p'>
          Growth Goals
        </Typography>
        <div>
          <IconTooltipButton
            title='Add question'
            icon='plus'
            classNameIcon='text-lg'
            style={{
              borderRadius: '0.5rem',
              padding: '0.45rem',
              color: 'var(--primary)',
              backgroundColor: '#fff',
              width: 25,
              height: 25
            }}
            className="shadow-sm"
            onClick={() => setModal({ type: 'create', form: {} })}
          />
        </div>
      </Box>
      <Box className='absolute top-36 bottom-0 inset-x-4'>
        <DataGrid
          id='add-remove-growth-goals'
          showSetting={false}
          loading={isLoading}
          rows={formData?.map((row, index) => {
            return {
              ...row,
              index: index + 1,
              actions: 
              <div className='flex items-center gap-1 items-center justify-center'>
                <IconTooltipButton
                  id={`edit-${row._id}`}
                  disabled={isLoading}
                  title='Edit'
                  icon='pen'
                  onClick={() => setModal({ type: 'edit', form: { ...row, id: row._id || row.id } })}
                />
                <IconTooltipButton
                  id={`delete-${row._id}`}
                  disabled={isLoading}
                  title='Delete'
                  icon='trash-alt'
                  onClick={() => setModal({ type: 'delete', form: { ...row, id: row._id || row.id } })}
                />
              </div>
            }
          })}
          rowsPerPage={formData?.length || 0}
          columns={[
            { label: '#', key: 'index', align: 'center', width: 20, show: true, hide: false },
            { label: 'Question', key: 'question', show: true, hide: false },
            { label: 'Actions', key: 'actions', align: 'center', width: 50, show: true, hide: false }
          ]}
          labelNoRows="You don't have any question yet"
        />
      </Box>
      { modal &&
        <DialogGrowthGoals
          open={modal}
          onClose={() => setModal(null)}
          formData={modal.form}
          onSave={onSave}
          type={modal.type}
        />
      } 
    </>
  )
}

export default FormGrowthGoals